












import Vue from 'vue'
import GlobalWrapper from '@/components/utils/GlobalWrapper.vue'
import TheHeader from '@/components/organisms/TheHeader.vue'
import TheFooter from '@/components/organisms/TheFooter.vue'

export default Vue.extend({
  components: {
    GlobalWrapper,
    TheHeader,
    TheFooter
  },
  computed: {
    isTopPageClass(): string {
      return this.$route.path === '/top' ? 'is-topPage' : ''
    }
  },
  mounted() {
    document.addEventListener('touchstart', function() {}, {
      passive: true
    })
  }
})
